import React from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { MyOrderDetail } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';

export function MyOrderDetailPage() {
    const { uuid } = useParams();
    const { t } = useTranslation();

    const translations = {
        title: t('my-order-detail-component.metatags.title'),
        description: t('my-order-detail-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myOrderDetail.replace(':uuid', `${uuid}`),
        index: false,
    });

    return <MyOrderDetail />;
}
